module.exports = __webpack_public_path__ + "static/media/1006058.4b998502.png";